import React from "react";
import "./HeaderBody.scss";
import HeaderNav from "../../../../components/Nav/HeaderNav/HeaderNav";
import { Link } from "react-router-dom";
import HeaderDropdown from "../../../../components/Nav/HeaderDropdown/HeaderDropdown";
import Search from "../../../../components/Search/Search";

function HeaderBody() {
  return (
    <>
      <div className="wrapper-header-body">
        <div className="lg-search">
          <div className="img-logo">
            <Link to="/" className="dibee-logo">
              <img
                src="/logo.png"
                alt="dibee marketplace"
                style={{
                  height: "50px",
                  width: "auto",
                  objectFit: "contain",
                }}
              />
            </Link>
          </div>
          <Search />
        </div>
        <HeaderDropdown />
      </div>
      <HeaderNav />
    </>
  );
}

export default HeaderBody;
